import React, { useEffect, useRef, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './SlExternalWindowPanel.scss';

export interface ISlExternalWindowPanelProps {
    children: React.ReactNode;
    isPanelOpen: boolean;
    shouldAnimate?: boolean;
    animationDuration?: number;
    onClose: () => void;
}

export const SlExternalWindowPanel: React.FC<ISlExternalWindowPanelProps> = React.memo(
    	({
    		children,
    		isPanelOpen,
    		shouldAnimate,
    		animationDuration = 500,
    		onClose,
    	}) => {
    		useStyles(s);
    		const [hasAnimation, setAnimation] = useState<boolean>(true);
    		const panel = useRef<HTMLDivElement>(null);

    		const onOutsideClick = (e: MouseEvent) => {
    			if (
    				panel.current
                    && !panel.current.contains(e.target as Node)
    			) {
    				onClose();
    			}
    		};
    		useEffect(() => {
    			document.addEventListener('click', onOutsideClick, true);
    			if (shouldAnimate) {
    				setTimeout(() => {
    					setAnimation(false);
    				}, animationDuration);
    			}
    			return () => {
    				document.removeEventListener('click', onOutsideClick, true);
    			};
    		}, []);

    		return (
	<div
				ref={panel}
				className={`sl-window-panel-shared${shouldAnimate && hasAnimation
    					? ' window-panel-slider slide-in-to-left'
    					: ''
    				}${shouldAnimate && !isPanelOpen
    					? ' slide-out-to-right'
    					: ''
    				}`}
			>
				{children}
			</div>
    		);
    	},
);
